import { render } from "./PersonalCat.vue?vue&type=template&id=0b4b6360&scoped=true"
import script from "./PersonalCat.vue?vue&type=script&lang=js"
export * from "./PersonalCat.vue?vue&type=script&lang=js"

import "./PersonalCat.vue?vue&type=style&index=0&id=0b4b6360&scoped=true&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b4b6360"]])

export default __exports__